/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import moment from 'moment';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, config} from 'Utils';
import {dmsPurchaseList, getCustomerReceivableDetail, getCustomerReceivableList} from '../../service/reportForm';
import {fetchChannelList} from "../../service/home";

class CustomerReceivableInquiry extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelId = window.sessionStorage.getItem('cur_channelId');
        this.state = {
            opts: ['客户应收余额查询'],
            channelCode: this.channelId,
            key: 0,
            id: '',
            selectedRowKeys: [],
            rows: [],
            total: 1,
            dataSource: [],
            detailTotal: 1,
            gouxiaoUnitList: [],
            searchObj: {
                salesChannelCode: '',
                s: 10,
                p: 1,
                startDate: moment().format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                salesUnitId: ''
            },
            loading: false
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    }

    goAdd() {
        let param = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/customerReceivable/exportExcel`;
        let urlStr = '';
        Object.keys(param).forEach(item => {
            urlStr += `&${item}=${param[item]}`;
        });
        url += `?${urlStr.substring(1)}`;
        window.open(url);
    }

    advanceReset() {
        let self = this;
        self.setState({
            searchObj: {
                s: 10,
                p: 1,
                startDate: '',
                endDate: '',
                salesUnitId: '',
                salesChannelCode: ''
            }, loading: false
        }, function () {
            //self.initData();
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        if (!this.state.searchObj.startDate || this.state.searchObj.startDate == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        if (!this.state.searchObj.endDate || this.state.searchObj.endDate == '') {
            openNotice('warning', '请选择日期范围后再做查询');
            return;
        }
        if (self.state.searchObj.salesUnitId == '') {
            openNotice('warning', '请选择购货单位');
            return
        }
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: false
        }, () => {
            self.initData();
        });
    };

    setFilterParam(name, value) {
        if (name === 'date') {
            this.setState({searchObj: {...this.state.searchObj, startDate: value.from, endDate: value.end}})
        } else {
            if (value == 'ALL') {
                this.setState({searchObj: {...this.state.searchObj, [name]: ''}})
            } else {
                this.setState({searchObj: {...this.state.searchObj, [name]: value}})
            }
        }
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    initData() {
        this.setState({
            loading: true
        });
        let searchObj = this.state.searchObj;
        getCustomerReceivableList(searchObj).then((result) => { //数据列表
            this.setState({
                'rows': result.data || [],
                'total': result.total || 1,
                loading: false
            });
        });
        getCustomerReceivableDetail(searchObj).then((result) => { //数据详情
            this.setState({
                'dataSource': result.data || [],
                'detailTotal': result.total || 1
            });
        });
    }

    componentDidMount() {
        let self = this;
        dmsPurchaseList({channelCode: this.state.channelCode, p: 1, s: 100}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                self.setState({gouxiaoUnitList: arr})
            }
        });
        /*渠道类型*/
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                self.setState({channel_type: arr},
                )
            }
        });
        // this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {
            opts,
            key,
            rows,
            total,
            dataSource,
            detailTotal,
            searchObj,
            gouxiaoUnitList,
            selectedRowKeys,
            loading,
            channel_type
        } = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'date',//startCreatedDate, endCreatedDate
                    label: '日期',
                    options: [
                        {text: '从'},
                        {text: '至'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.startDate || '',
                        end: searchObj.endDate || ''
                    }
                }, {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '请选择',
                    type: 'select',
                    showSearch: true,
                    options: gouxiaoUnitList,
                    defaultValue: searchObj.salesUnitId
                }, {
                    name: 'salesChannelCode',
                    label: '渠道',
                    text: '选择渠道',
                    options: channel_type,
                    multiple: false,//支持多选
                    type: 'select',
                    defaultValue: false,
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'rn',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '客户名称',
                    dataIndex: 'customerName',
                }, {
                    title: '购货单位',
                    dataIndex: 'salesUnitName',
                }, {
                    title: '期初欠款',
                    dataIndex: 'initAmount'
                }, {
                    title: '借方-提货',
                    dataIndex: 'drShipped'
                }, {
                    title: '借方-退货',
                    dataIndex: 'drBack'
                }, {
                    title: '借方-维修费发票',
                    dataIndex: 'drRepair'
                }, {
                    title: '借方-价外费用',
                    dataIndex: 'drPriceex'
                }, {
                    title: '借方-债权债务转移',
                    dataIndex: 'drDebet'
                }, {
                    title: '借方-坏帐收回',
                    dataIndex: 'drBaddebt'
                }, {
                    title: '借方-退货扣点',
                    dataIndex: 'drGoodsreturn'
                }, {
                    title: '借方-退货服务发票',
                    dataIndex: 'drReturn'
                }, {
                    title: '借方-其他',
                    dataIndex: 'drOthers'
                }, {
                    title: '贷方-回款',
                    dataIndex: 'crReceipt'
                }, {
                    title: '贷方-退款',
                    dataIndex: 'crReturnc'
                }, {
                    title: '贷方-债权债务转移',
                    dataIndex: 'crDebet'
                }, {
                    title: '贷方-坏帐核销',
                    dataIndex: 'crBaddebt'
                }, {
                    title: '贷方-销售折扣',
                    dataIndex: 'crDiscount'
                }, {
                    title: '贷方-其他',
                    dataIndex: 'crOthers'
                }, {
                    title: '期末欠款',
                    dataIndex: 'endAmount'
                }, {
                    title: '折扣折让余额',
                    dataIndex: 'discountAmount'
                }
            ],
            rows
        };
        const tableViewProps2 = {
            loading: loading,//更新表格数据中
            rowKey: 'rn',
            pageParam: {
                total: detailTotal,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '销售组织',
                    dataIndex: 'ouName',
                }, {
                    title: '单据类型',
                    dataIndex: 'typeName',
                }, {
                    title: '单据编号',
                    dataIndex: 'trxNumber',
                }, {
                    title: '出库单号',
                    dataIndex: 'deliveryId',
                }, {
                    title: '单据日期',
                    dataIndex: 'trxDate'
                }, {
                    title: '购货单位',
                    dataIndex: 'salesUnitName',
                }, {
                    title: '发票金额',
                    dataIndex: 'amount',
                }, {
                    title: '汇款金额',
                    dataIndex: 'recAmount',
                }
            ],
            rows: dataSource
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew  {...filterBoxProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button onClick={this.goAdd.bind(this)} style={{position: 'absolute', bottom: 8, right: 0}}
                            icon="export">导出</Button>
                </div>
                <TableView {...tableViewProps} />
                <TableView {...tableViewProps2} />
            </div>
        </div>
    }
}
;
export default withRouter(CustomerReceivableInquiry);


// WEBPACK FOOTER //
// ./src/routes/reportForm/customerReceivableInquiry.js